

exports.__esModule = true;
exports.$guestThrottle = $guestThrottle;

var _angular = require('angular');

var _squid = require('squid');

var _logger = require('xo-beaver/dist/logger');

var _index = require('xo-models/src/checkout/index');

function $guestThrottle(flowName, token, lang, country) {
    var models = {};

    function redirectToXoon() {
        return (0, _squid.$dispatch)('xoon', {
            exp: flowName,
            token: token,
            'locale.x': lang + '_' + country,
            'country.x': country
        });
    }

    function fallback(product, reason, params) {
        throw new _squid.$FallbackError({
            product: product || 'ux',
            reason: reason,
            entryPoint: flowName,
            params: params
        });
    }

    function checkInstantUpdateGuestEnabled() {
        return (0, _squid.$pxp)('xoonboardingnodeweb_instant_update_throttle', 'xoonboardingnodeweb_instant_update_throttle_treatment').then(function (result) {
            var treatmentName = result && result.treatment_name || '';
            return treatmentName === 'xoonboardingnodeweb_instant_update_throttle_treatment';
        });
    }

    function isGuestFlowEnabled() {
        if (_angular.$rootScope.wps) {
            if (!_squid.$config.enableGuestWps) {
                // Fallback to UX for WPS transactions if guest option disabled
                return _angular.$q.resolve(false);
            }
            return (0, _squid.$populate)(models, {
                checkoutCart: _index.$CheckoutCartModel.instance(token).retrieve()
            }).then(function () {
                var cart = models.checkoutCart;
                /*
                 1. For SnT and inventory flows , return true enabling guest flows always.
                 2. For Instant update flows , enable guest flows if treatment name is returned else fallback
                 */
                if (cart.instantUpdateIntegration) {
                    return checkInstantUpdateGuestEnabled();
                } else {
                    return _angular.$q.resolve(true);
                }
            });
        }
        // Allow EC-flows to xoon always
        return _angular.$q.resolve(true);
    }

    return isGuestFlowEnabled().then(function (res) {
        if (!res) {
            _logger.$logger.info(flowName + '_to_ux_wps');
            return fallback('ux', flowName + '_to_ux_wps');
        }
        return redirectToXoon();
    });
}

angular.value("$guestThrottle", $guestThrottle);
_angular.$rootScope;

_angular.$q;

_squid.$dispatch;

_squid.$populate;

_squid.$config;

_squid.$FallbackError;

_squid.$pxp;

_logger.$logger;

_index.$CheckoutCartModel;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-login/guestThrottle.js
// module id = ./pages/xo-login/guestThrottle.js
// module chunks = 1